import { useState } from "react";
import CloseIcon from "../../../assets/crossIcon.svg";
import { PreinitiateServices } from "../../../services/PreinitiateServices";
import DownloadIcon from "../../../assets/downloadIconGreen.svg";
import { CircularProgress } from "@mui/material";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CaseServices } from "../../../services/CaseServices";
const RejectionPopUp = ({ isOpen, selectedDoc, getDocumentsData }) => {
  const [status, setStatus] = useState("REJECTED");
  const [rejectionReason, setRejectionReason] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  console.log("selected doc:", selectedDoc);
  const handleRejectDocument = async () => {
    setLoading(true);
    const data = [
      {
        documentId: selectedDoc?.docs[selectedImage].id,
        status: status,
        rejectionReason: rejectionReason,
      },
    ];
    // Stage update on rejection commented out — backend handles it now
    // const subMasterStageData = {
    //   hsaStage: "Reference Document Rejected",
    //   commandCeneterStage: "Reference Document Rejected",
    //   nextStepUser: "HSA",
    //   caseDetails: [
    //     {
    //       query: "",
    //       queryResponse: "",
    //     },
    //   ],
    // };
    if (rejectionReason) {
      try {
        await PreinitiateServices.updateReferenceDocumentStatus(
          data,
          selectedDoc?.docs[selectedImage].caseId,
        );
        window.alert("Document Rejected Successfully");
        // const stageResponse = await CaseServices.updateSubMasterStage(
        //   selectedDoc?.docs[selectedImage]?.caseId,
        //   subMasterStageData,
        // );
        // window.alert(stageResponse.data.message);
        isOpen(false);
        getDocumentsData();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("Rejection Reason Required");
    }

    setLoading(false);
  };
  return (
    <div className="fixed top-0 left-0 h-full w-full flex justify-center items-center bg-[#017C5780] z-30">
      <div className="relative bg-white rounded-[16px] w-[90%] h-[90%] xl:w-[50%] xl:h-[95%] p-4 xl:p-8">
        <div
          className="absolute top-2 right-2 xl:top-4 xl:right-5 2xl:top-2 2xl:right-4 cursor-pointer z-20"
          onClick={() => isOpen(false)}
        >
          <img src={CloseIcon} height={30} width={30} alt="close-icon" />
        </div>

        <div className=" max-h-[70%] 2xl:max-h-[80%] w-full flex justify-center bg-red-200 overflow-y-auto">
          {selectedDoc?.docs[selectedImage]?.documentUrl?.slice(-3) ===
          "pdf" ? (
            <iframe
              src={`http://docs.google.com/gview?url=${selectedDoc.documentUrl}&embedded=true`}
              fgrameborder="0"
              height="100%"
              width="100%"
            />
          ) : (
            <img
              src={selectedDoc?.docs[selectedImage]?.documentUrl}
              style={{
                border:
                  selectedDoc?.docs[selectedImage]?.status === "REJECTED"
                    ? "3px solid #CF363670"
                    : "",
              }}
              alt="doc-image"
              className=" h-[100%] w-full object-contain"
              // className="h-[70%]"
            />
          )}
          <a
            href={selectedDoc?.docs[selectedImage].documentUrl}
            className="absolute top-5 right-12 xl:top-2 xl:right-12  cursor-pointer"
          >
            <img src={DownloadIcon} alt="download-icon" />
          </a>
        </div>
        <div className="flex gap-2 flex-wrap overflow-y-scroll h-[90px]">
          {selectedDoc?.docs?.map((doc, idx) => {
            return (
              <div
                key={idx}
                style={{
                  border:
                    doc.status === "REJECTED"
                      ? "3px solid #CF363630"
                      : selectedImage === idx
                        ? "1px solid #017C57"
                        : "1px solid #E4E4E4",
                  boxShadow:
                    selectedImage === idx && "0 1px 10px rgba(0, 0, 0, 0.5)",
                  borderRadius: "8px",
                }}
                onClick={() => setSelectedImage(idx)}
              >
                <img
                  src={doc.documentUrl}
                  width={80}
                  height={80}
                  alt="uploaded-image"
                  style={{ borderRadius: "8px" }}
                />
              </div>
            );
          })}
        </div>
        <div className="flex justify-center mt-2 ">
          <input
            type="text"
            placeholder="Rejection Reason"
            style={{ border: "1px solid #e4e4e4" }}
            className="h-[40px] font-semibold text-sm text-[#797979] rounded-[8px]
            pl-[12px] w-[100%] xl:w-[50%]"
            onChange={(e) => setRejectionReason(e.target.value)}
          />
        </div>

        <div className=" mt-2 ">
          {isLoading ? (
            <div className="flex justify-center">
              <CircularProgress />
            </div>
          ) : confirmation ? (
            <div className="flex justify-around items-center">
              <div className="text-xl font-medium text-[#191919]">
                Are you sure you want to reject
              </div>{" "}
              <div className="text-sm flex gap-2">
                <div
                  className="text-xs text-white bg-[#017C57] px-8 py-2 rounded-full cursor-pointer"
                  onClick={() => setConfirmation(false)}
                >
                  NO
                </div>
                <div
                  className="text-xs text-white bg-[#017C57] px-8 py-2 rounded-full cursor-pointer"
                  onClick={handleRejectDocument}
                >
                  YES
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center">
              <div
                className="text-xs text-white bg-[#017C57] h-fit w-fit cursor-pointer rounded-full px-12 py-2"
                onClick={() => setConfirmation(true)}
              >
                REJECT
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RejectionPopUp;
